<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { Dashboard } from "@/services/westore/entities";
import { Analytics } from "@/services/westore/entities";
import { mapGetters } from "vuex";
import SkeletonLoader from "../../../components/skeletons/skeleton-loader.vue";
import { pieChart } from "./data-apex";
import { analyticsChart } from "./analytics-apex";
import { warehousingChart } from "./warehousing-analytics";
import moment from "moment";

export default {
  page: {
    title: "Home",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    SkeletonLoader,
  },
  data() {
    return {
      title: "Dashboard Overview",
      subtitle: "Here you can take an overview look on everything..",
      subLinks: [
        {
          title: "Add New Order",
          createPath: "/orders/create",
        },
        {
          title: "Add New Inbound",
          createPath: "/inbound-shipments/create",
        },

        {
          title: "Add New Support Ticket",
          createPath: "/support-tickets/create",
        },
      ],
      breadcrumb: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      statistics: {
        orders_delivered_today: 0,
        orders_to_be_delivered_today: 0,
      },
      cod: {
        today: 0,
        this_week: 0,
        this_month: 0,
      },
      recentUpdates: [],
      orders: [],
      sku: [],
      last_inbound: {},
      items_sold_today: 0,
      items_sold_this_week: 0,
      items_sold_this_month: 0,
      orders_to_be_dispatched_today: 0,

      merchant_services: [],
      showVerificationWarning: false,
      showContentLoader: true,
      offset: true,
      pieChart: pieChart,
      analyticsChart: analyticsChart,
      warehousingChart: warehousingChart,
      date: moment(new Date()).format("YYYY-MM"),
      analyticsData: "",
      menu: false,
      analyticsMenu: false,
      modal: false,
      filter: {
        month: null,
        year: null,
      },
      donutChart: {
        chartOptions: {
          labels: [
            this.$t("In Stock"),
            this.$t("Needs Restocking"),
            this.$t("Out Of Stock"),
          ],
          colors: ["#65CD54", "#331435", "#CB3243"],
          legend: {
            show: true,
            position: "right",
            verticalAlign: "middle",
            horezintalAlign: "center",
            floating: false,
            fontSize: "13px",
            offsetY: 100,
            offsetX: 0,

            formatter: function (seriesName, opts) {
              return [
                seriesName,
                " : ",
                opts.w.globals.series[opts.seriesIndex],
              ];
            },
            markers: {
              radius: 0,
            },
            itemMargin: {
              vertical: 3,
            },
          },
          title: {
            text: this.$t("Inventory"),
            align: "left",
            margin: 15,
            offsetX: 110,
            offsetY: 10,
            floating: false,
            style: {
              fontSize: "15px",
              fontWeight: "600",
              color: "#263238",
            },
          },

          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    show: true,
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 600,
              options: {
                chart: {
                  height: 240,
                },
                legend: {
                  show: true,
                  offsetY: 60,
                },
              },
            },
          ],
        },
      },
    };
  },

  mounted() {
    this.fetchData();
    this.fetchanalyticsData();
    this.applyFilter();
    this.checkEmailVerification();
  },
  computed: {
    ...mapGetters({
      verified: "auth/verified",
      verificationMessage: "auth/verificationMessage",
    }),
    dateFormatted() {
      return this.formatDate(this.date);
    },
  },

  methods: {
    checkEmailVerification() {
      if (!this.verified) {
        setTimeout(() => {
          this.showVerificationWarning = true;
        }, 1500);
      }
    },
    async fetchData() {
      let requestParams = {
        ...this.filter,
      };
      try {
        const {
          orders_recent_activities,
          skus_quantities,
          monthly_report,
          orders_delivered_today,
          orders_to_be_delivered_today,
          collected_cod,
          merchant_services,
          top_SKUs,
          last_inbound,
          items_sold_today,
          items_sold_this_week,
          items_sold_this_month,
          orders_to_be_dispatched_today,
        } = await Dashboard.getStatistics(requestParams);
        this.statistics = {
          orders_delivered_today,
          orders_to_be_delivered_today,
        };
        this.cod = collected_cod;
        this.recentUpdates = orders_recent_activities.data;
        this.sku = skus_quantities;
        this.orders = monthly_report.orders_status_groups;
        this.merchant_services = merchant_services.map((x) => {
          return x.value;
        });
        this.top_SKUs = top_SKUs;
        this.last_inbound = last_inbound || last_inbound.shipment == null;
        this.items_sold_today = items_sold_today;
        this.items_sold_this_week = items_sold_this_week;
        this.items_sold_this_month = items_sold_this_month;
        this.orders_to_be_dispatched_today = orders_to_be_dispatched_today;

        //Warehousing-Analytics
        this.warehousingChart.series[0].data = this.top_SKUs.map((x) => {
          return x.sold_items;
        });
        this.warehousingChart.chartOptions.xaxis.categories = this.top_SKUs.map(
          (x) => {
            return x.sku;
          }
        );
      } catch (error) {
        console.log("error", error);
        // this.$toast.error("Something went wrong,please try again");
      } finally {
        this.showContentLoader = false;
      }
    },
    async fetchanalyticsData() {
      let requestParams = {
        ...this.filter,
      };
      try {
        this.response = await Analytics.getAnalytics(requestParams);
        this.analyticsChart.series[0].data = Object.values(this.response);
      } catch (error) {
        this.$toast.error("Something went wrong,please try again");
      } finally {
        // this.showContentLoader = false;
      }
    },
    applyFilter() {
      let dateFormatted = this.date.split("-");
      this.filter = {
        year: dateFormatted[0],
        month: parseInt(dateFormatted[1]),
      };
      this.fetchData();
    },
    applyFilterAnalytics() {
      let analyticsdateFormatted = this.analyticsData.split("-");
      this.filter = {
        year: analyticsdateFormatted[0],
      };
      this.fetchanalyticsData();
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month] = date.split("-");
      return `${month}-${year}`;
    },
    convertDate: function (timestampValue) {
      return moment.unix(timestampValue).format("DD/MM/YYYY");
    },
  },
};
</script>

<template>
  <Layout class="bg-white">
    <PageHeader :title="title" :subtitle="subtitle">
      <v-menu
        offset-y
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" v-bind="attrs" v-on="on">
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </template>

        <v-list v-for="(subLink, index) in subLinks" :key="index">
          <router-link :to="`${subLink.createPath}`">
            <v-list-item>
              <v-list-item-title>{{ $t(subLink.title) }}</v-list-item-title>
            </v-list-item>
          </router-link>
        </v-list>
      </v-menu>
    </PageHeader>

    <div class="mb-5">
      <v-row v-if="showContentLoader">
        <v-col v-for="(n, index) in 5" :key="index + 5" lg="">
          <SkeletonLoader type="divider, image" />
        </v-col>
        <v-col cols="12">
          <SkeletonLoader type="divider, image" />
        </v-col>
        <v-col v-for="n in 2" :key="n" cols="12" md="6">
          <SkeletonLoader type="list-item-avatar, divider, image" />
        </v-col>
      </v-row>
      <!--start-row-->
      <div v-else>
        <b-row class="mt-5">
          <div class="line-wrap mb-4">
            <span>Wrap Up</span>
            <hr />
          </div>
          <!----Orders delivered today---->
          <b-col lg="" sm="12">
            <!--Warehousing-->
            <b-card v-if="this.merchant_services.includes(1)" class="cod-card">
              <v-icon size="55" class="my-1">
                $vuetify.icons.ordersDeliverd
              </v-icon>
              <div class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  {{ orders_to_be_dispatched_today }}
                </p>
                <p class="cod-content">
                  <span>{{ $t("Orders to be dispatched") }}</span>
                  <span>{{ $t("Today") }}</span>
                </p>
              </div>
            </b-card>
            <!--LastMile-->
            <b-card v-else class="cod-card">
              <v-icon size="55" class="my-1">
                $vuetify.icons.ordersDeliverd
              </v-icon>
              <div class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  {{ statistics.orders_delivered_today }}
                </p>
                <p class="cod-content">
                  <span>{{ $t("Orders delivered") }}</span>
                  <span>{{ $t("Today") }}</span>
                </p>
              </div>
            </b-card>
          </b-col>
          <!----Orders to be delivered---->
          <b-col lg="" sm="12">
            <!--Warehousing-->
            <b-card v-if="this.merchant_services.includes(1)" class="cod-card">
              <div class="icon-wrapper2">
                <img
                  height="40"
                  src="../../../assets/icons/SVG/inventory.svg"
                />
              </div>
              <div class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  {{ items_sold_today }}
                </p>
                <p class="cod-content">
                  <span> {{ $t("Items Dispatched") }} </span>
                  <span>{{ $t("Today") }}</span>
                </p>
              </div>
            </b-card>
            <!--LastMile-->
            <b-card v-else class="cod-card">
              <v-icon size="55" class="my-1">
                $vuetify.icons.tobeDelivered
              </v-icon>
              <div class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  {{ statistics.orders_to_be_delivered_today }}
                </p>
                <p class="cod-content">
                  <span> {{ $t("to be delivered") }} </span>
                  <span>{{ $t("Today") }}</span>
                </p>
              </div>
            </b-card>
          </b-col>
          <!---- Cod Today ---->
          <b-col lg="" sm="12">
            <!--Warehousing-->
            <b-card v-if="this.merchant_services.includes(1)" class="cod-card">
              <div class="icon-wrapper2">
                <img
                  height="40"
                  src="../../../assets/icons/SVG/inventory.svg"
                />
              </div>
              <div class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  <span>{{ items_sold_this_week }}</span>
                </p>
                <p class="cod-content">
                  <span>{{ $t("Items Dispatched") }}</span>
                  <span>{{ $t("This Week") }}</span>
                </p>
              </div>
            </b-card>
            <!--LastMile-->
            <b-card v-else class="cod-card">
              <v-icon size="55" class="my-1"> $vuetify.icons.codIcon </v-icon>
              <div class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  <span>{{ cod.today }}</span>
                  <span class="currency">{{ $t("AED") }}</span>
                </p>
                <p class="cod-content">
                  <span>{{ $t("COD Collected") }}</span>
                  <span>{{ $t("Today") }}</span>
                </p>
              </div>
            </b-card>
          </b-col>
          <!---- Cod This week ---->
          <b-col lg="" sm="12">
            <!--Warehousing-->
            <b-card v-if="this.merchant_services.includes(1)" class="cod-card">
              <div class="icon-wrapper2">
                <img
                  height="40"
                  src="../../../assets/icons/SVG/inventory.svg"
                />
              </div>
              <div class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  <span>{{ items_sold_this_month }}</span>
                </p>
                <p class="cod-content">
                  <span>{{ $t("Items Dispatched") }}</span>
                  <span>{{ $t("This Month") }}</span>
                </p>
              </div>
            </b-card>
            <!--LastMile-->
            <b-card v-else class="cod-card">
              <v-icon size="55" class="my-1">
                $vuetify.icons.codDarkIcon
              </v-icon>
              <div class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  <span>{{ cod.this_week }}</span>
                  <span class="currency">{{ $t("AED") }}</span>
                </p>
                <p class="cod-content">
                  <span>{{ $t("COD Collected") }}</span>
                  <span class="f-word">{{ $t("Week") }}</span>
                </p>
              </div>
            </b-card>
          </b-col>
          <!---- Cod This Month ---->
          <b-col lg="" sm="12">
            <!--Warehousing-->
            <b-card
              @click="
                $router.push({
                  name: 'inbound-shipment-details',
                  params: { id: last_inbound.id },
                })
              "
              v-if="this.merchant_services.includes(1)"
              class="cod-card"
              style="cursor: pointer"
            >
              <div class="icon-wrapper2">
                <v-icon size="40"> $vuetify.icons.inboundShipment </v-icon>
              </div>
              <div v-if="Object.keys( last_inbound ).length != 0" class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  <span> #{{ last_inbound.shipment_number }}</span>
                </p>
                <p class="cod-content">
                  <span>{{ $t("Last inbound") }}</span>
                  <span
                    class="d-block font-size-13 initiated-badge mx-auto my-1 text-white"
                    style="border-radius: 5px; padding: 5px; width: 80px"
                    >{{ last_inbound.status }}</span
                  >
                  <span>{{ convertDate(last_inbound.timestamp) }}</span>
                </p>
              </div>
              <div v-else class="cod-wrapper mt-10">
                <p class="cod-content">
                  <span>{{ $t("No inbound") }}</span>
                </p>
              </div>
            </b-card>
            <!--LastMile-->
            <b-card v-else class="cod-card">
              <v-icon size="55" class="my-1">
                $vuetify.icons.codDarkIcon
              </v-icon>
              <div class="cod-wrapper">
                <p class="cod-number my-lg-1">
                  <span> {{ cod.this_month }}</span>
                  <span class="currency">{{ $t("AED") }}</span>
                </p>
                <p class="cod-content">
                  <span>{{ $t("COD Collected") }}</span>
                  <span class="f-word">{{ $t("Month") }}</span>
                </p>
              </div>
            </b-card>
          </b-col>
          <!----Analytics---->
          <div class="line-wrap my-4">
            <span>Analytics</span>
            <hr />
          </div>
          <b-col class="analytics" cols="12">
            <div
              class="mb-lg-6 mb-3 d-flex justify-content-between align-items-center"
            >
              <h3
                v-if="this.merchant_services.includes(1)"
                class="font-size-18 text-primary mb-0"
              >
                Active Skus
              </h3>
              <h3 v-else class="font-size-18 text-primary mb-0">COD Balance</h3>

              <div
                v-if="!this.merchant_services.includes(1)"
                class="year-picker p-2"
              >
                <v-menu
                  ref="analyticsMenu"
                  v-model="analyticsMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="analyticsData"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      :placeholder="$t('Select Year')"
                      class="ml-3 fw-medium font-size-14"
                    >
                      <template v-slot:prepend>
                        <img
                          width="20"
                          height="20"
                          src="../../../assets/icons/SVG/calendar.svg"
                        />
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="analyticsData"
                    type="month"
                    color="info"
                    no-title
                    prepend-icon="event"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click="analyticsMenu = false">
                      {{ $t("Cancel") }}
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        applyFilterAnalytics(
                          $refs.analyticsMenu.save(analyticsData)
                        )
                      "
                    >
                      {{ $t("Ok") }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <b-card v-if="this.merchant_services.includes(1)" class="py-0 px-3">
              <div class="pr-lg-5" id="warehousingChart">
                <div
                  v-if="top_SKUs.length === 0"
                  class="d-flex justify-content-center align-items-center flex-column"
                >
                  <p class="text-info mb-3 fw-smibold font-size-18">
                    {{ $t("No Skus yet..") }}
                  </p>
                  <img
                    class="py-3 placeholder-img"
                    height="240"
                    src="../../../assets/images/recent-update-placeholder.svg"
                    alt=""
                  />
                </div>
                <apexchart
                  v-else
                  type="bar"
                  height="350"
                  :series="warehousingChart.series"
                  :options="warehousingChart.chartOptions"
                ></apexchart>
              </div>
            </b-card>
            <b-card v-else class="py-0 px-3">
              <div class="pr-lg-15" id="chart">
                <apexchart
                  type="bar"
                  height="350"
                  :series="analyticsChart.series"
                  :options="analyticsChart.chartOptions"
                ></apexchart>
              </div>
            </b-card>
          </b-col>
          <!----Recent Updates---->
          <b-col>
            <h3 class="mb-5 font-size-18 text-primary">
              {{ $t("Recent Updates") }}
            </h3>
            <b-card class="py-0 px-3">
              <div
                v-if="recentUpdates.length === 0"
                class="d-flex justify-content-center align-items-center flex-column"
              >
                <p class="text-info mb-3 fw-smibold font-size-18">
                  {{ $t("No updates yet..") }}
                </p>
                <img
                  class="py-3 placeholder-img"
                  height="240"
                  src="../../../assets/images/recent-update-placeholder.svg"
                  alt=""
                />
              </div>
              <div
                v-else
                v-for="(
                  { time, subject_type, subject_number, event, status }, index
                ) in recentUpdates"
                :key="index"
                class="d-flex justify-content-start align-items-center mb-2"
              >
                <span class="text-info">{{ time }}</span>
                <div class="bg-light-gray rounded flex-grow-1 ml-4 px-3 py-2">
                  <p v-if="event === 'updated'" class="font-size-14 mb-0">
                    {{ subject_type }}
                    <span>{{ subject_number }}'s </span>
                    status has been changed to
                    <span>{{ status }}</span>
                  </p>
                  <p v-else class="font-size-14 mb-0">
                    {{ subject_type }}
                    <span>{{ subject_number }}</span>
                    has been
                    <span>{{ event }}</span>
                  </p>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <!--end-row-->

        <!--start-row-->
        <b-row>
          <h3 class="mb-5 font-size-18 text-primary">{{ $t("Statistics") }}</h3>
          <b-col>
            <div class="card mb-0 h-100">
              <div
                class="d-flex justify-content-start align-items-center rounded bg-light-gray p-3 card-head"
              >
                <div
                  class="p-1 rounded icon-wrapper"
                  :class="isRtl ? 'ml-2' : 'ml-0'"
                >
                  <v-icon size="20"> $vuetify.icons.date </v-icon>
                </div>

                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateFormatted"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :placeholder="$t('Select Month')"
                      class="ml-3 fw-medium font-size-14"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    type="month"
                    no-title
                    color="primary"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click="menu = false">
                      {{ $t("Cancel") }}
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="applyFilter($refs.menu.save(date))"
                    >
                      {{ $t("Ok") }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div
                class="d-flex justify-content-center flex-column"
                v-if="orders.every((item) => item === 0)"
              >
                <p class="text-info text-center my-3 fw-smibold font-size-18">
                  {{ $t("No orders yet..") }}
                </p>
                <img
                  class="py-3 placeholder-img"
                  height="200"
                  src="../../../assets/images/recent-update-placeholder.svg"
                  alt=""
                />
              </div>

              <!-- Pie Chart -->
              <apexchart
                v-else
                class="apex-charts"
                height="290"
                type="pie"
                dir="ltr"
                :series="orders"
                :options="pieChart.chartOptions"
              >
              </apexchart>
            </div>
          </b-col>
          <b-col
            v-if="
              this.merchant_services.includes(1) || this.merchant_services == []
            "
          >
            <div class="card h-100">
              <div
                class="d-flex justify-content-start align-items-center rounded bg-light-gray p-3 card-head"
              >
                <div class="p-1 rounded icon-wrapper">
                  <v-icon size="20"> $vuetify.icons.stock </v-icon>
                </div>
                <span
                  class="text-muted fw-medium"
                  :class="isRtl ? 'mr-3' : 'ml-3'"
                >
                  {{ $t("Current Stock") }}
                </span>
              </div>
              <img
                class="mx-auto placeholder-img"
                height="290"
                src="../../../assets/images/donut-placeholder.svg"
                alt=""
                v-if="sku.every((item) => item === 0)"
              />
              <!-- Donut Chart -->
              <apexchart
                v-else
                class="apex-charts fc-direction-rtl"
                height="290"
                type="donut"
                dir="ltr"
                :series="sku"
                :options="donutChart.chartOptions"
              ></apexchart>
            </div>
          </b-col>
        </b-row>
        <!--end-row-->
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
.v-list-item {
  min-height: 35px;
  border: 1px solid #48beea;
  background: #ffffff;
  border-radius: 5px;
}
.v-sheet.v-list {
  background: #f5f6f7;
  padding: 5px 10px;
}
.v-menu__content {
  margin-top: 10px;
  padding: 5px 0px;
  background: #f5f6f7;
}
.v-btn:not(.v-btn--round).v-size--default {
  min-width: 40px;
  height: 36px;
  padding: 0;
}
.bg-light-gray {
  background: #f5f6f7;
}
.icon-wrapper {
  background: #48beea;
  border-radius: 2px;
}
.icon-wrapper2 {
  background: #101820;
  border-radius: 3px;
  width: fit-content;
  padding: 10px 8px;
  margin: 0 auto;
}
</style>

<style>
#warehousingChart #apexchartsmychart svg {
  margin: 10px 10px 5px -30px;
}
#warehousingChart #apexchartsmychart {
  position: relative;
}
#warehousingChart #apexchartsmychart::after {
  content: "Sku Code";
  position: absolute;
  right: -25px;
  bottom: 18px;
  color: #e33065;
}
.apex-charts text {
  fill: #495057;
}
.apexcharts-legend-text,
.apex-charts text {
  font-family: "Montserrat-Medium" !important;
}

.apexcharts-legend-text {
  transition: 0.3s ease all;
}
.apexcharts-legend-text:hover {
  color: #101820 !important;
}
.v-input__slot {
  margin-bottom: 0;
}
.v-input input {
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: var(--v-info-base);
}
.theme--light.v-text-field > .v-input__control > .v-input__slot:before,
.v-text-field > .v-input__control > .v-input__slot:after {
  border: none;
}

.apexcharts-yaxis text,
.apexcharts-yaxis-texts-g text,
.apexcharts-xaxis-texts-g text,
.apexcharts-xaxis text {
  fill: #e33065 !important;
  font-family: "Lato" !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}
.apexcharts-yaxis-texts-g text {
  font-size: 14px;
  fill: #57697b !important;
}
.apexcharts-xaxis-texts-g text {
  font-size: 14px;
  fill: #9aa5b0 !important;
}
</style>
